export default __webpack_public_path__ + "static/media/trumper_wide.7849bb88.png";